import { alpha, color, display } from "@mui/system";

import { fonts, gutterX } from "../shared/ticketLayout";

const styles = (theme) => ({
  containerBodyModal: { height: "70%", overflowY: "auto" },
  boxBodyModal: { px: gutterX, pb: 1.25 },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: "bold",
    marginBottom: "5px",
    marginTop: "15px",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "50px",
    px: gutterX,
  },
  containerTitleComponent: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    justifyContent: "center",
  },
  containerPaperModal: {
    width: "100%",
    borderRadius: "16px",
    padding: 2,
    overflowY: "auto",
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  containerTitleReport: {
    display: "flex",
    alignItems: "center",

    justifyContent: "space-between",
    width: "100%",
  },
  boxTime: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: "center",
  },
  titleReport: {
    fontWeight: "bold",
    fontSize: fonts.sectionTitle,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  chipTime: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    border: "0.6px solid ",
    borderColor: theme.palette.primary.main,
    borderRadius: "10px",
  },
  containerPaperMensagem: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  bodyMensagem: {
    flexDirection: "column",
    padding: 2,
    display: "flex",
    gap: 2,
    alignItems: "center",
  },
  namePerson: {
    fontSize: fonts.body,
  },
  iconHeader: {
    fontSize: "20px",
    color: theme.palette.primary.main,
  },
  containerHeaderMensagem: {
    display: "flex",
    p: 0.3,
    alignItems: "center",
    gap: 0.5,
  },
  boxRouting: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  containerRouting: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  routing: {
    fontSize: fonts.label,
  },
  containerPersons: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  boxPersons: { width: "100%", display: "flex", gap: 3 },
  containerDescription: {
    display: "flex",
    flexDirection: "column",
    padding: 2,
  },
  titleDescription: {
    fontWeight: "bold",
    fontSize: fonts.sectionTitle,
  },
  description: { whiteSpace: "pre-line", fontSize: fonts.sectionTitle },
});

export default styles;
